/*=========================================================================================
  File Name: module-notification-actions.js
  Description: Notification Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	NotificationList: function(state) {
		return state.NotificationList;
	},
	TotalList: function(state) {
		return state.TotalList;
	},
	notificationLoaded: function(state) {
		return state.notificationLoaded;
	},
	countIsNewNumber: function(state) {
		return state.countIsNewNumber;
	},
	notifToken: function(state) {
		return state.notifToken;
	},
	notifTokenExpiry: function(state) {
		return state.notifTokenExpiry;
	},
	misaNotifShowing: function(state) {
		return state.misaNotifShowing;
	}
};
